import analytic from './requests/analytic/endpoints';
import charts from './requests/charts/endpoints';
import profiles from './requests/profiles/endpoints';
import artist from './requests/artist/endpoints';
import search from './requests/search/endpoints';
import album from './requests/album/endpoints';
import track from './requests/track/endpoints';
import playlist from './requests/playlist/endpoints';
import live from './requests/live/endpoints';
import deliveryMonitoring from './requests/deliveryMonitoring/endpoints';
import user from './requests/user/endpoints';

export default {
	analytic,
	charts,
	profiles,
	artist,
	search,
	album,
	track,
	playlist,
	live,
	deliveryMonitoring,
	user,
};
